export default __webpack_public_path__ + "static/N0120-9f086d604cd6faf1a083cba1e7e13466.png";